// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0cee8e28","726":"f714e86f"}[chunkId] + ".chunk.js";
};